import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { buildBreadcrumbs } from '../Breadcrumbs/Breadcrumbs.helpers';
import * as S from './SearchBaseResults.styles';
import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { useAdsCount } from '@/hooks/useAdsCount';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { getCurrentCategoryPath } from '@/hooks/useCurrentCategory/useCurrentCategory.helpers';
import { useServerDataContext } from '@/contexts';
import { addSpacesBetweenNumbers } from '@/utils/helpers';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface SearchBaseResultsProps {
  isHidden?: boolean;
}

export const SearchBaseResults: FC<SearchBaseResultsProps> = ({ isHidden }) => {
  const { currentCategory: serverCurrentCategory, h1 } = useServerDataContext();
  const { currentCategory = serverCurrentCategory } = useCurrentCategory();
  const { adsCount, loading: adsCountLoading } = useAdsCount(currentCategory);
  const {
    query: { slug },
  } = useRouter();

  const hasCount = adsCount !== undefined && adsCount !== null;

  return (
    <S.Box $isHidden={isHidden}>
      <Breadcrumbs
        isHidden
        hasHorizontalPadding
        nestingLvl={getCurrentCategoryPath(slug).split('/').length}
        breadcrumbs={buildBreadcrumbs(currentCategory)}
      />
      <S.InnerBox>
        {h1?.length ? (
          <>
            <S.Title as="h1" $variant="2">
              {h1}
              {(hasCount || adsCountLoading) && (
                <S.Amount>
                  {adsCountLoading ? (
                    <SkeletonLoader as="span" width={40} height={14} />
                  ) : (
                    hasCount && (
                      <>({addSpacesBetweenNumbers(adsCount.toString())})</>
                    )
                  )}
                </S.Amount>
              )}
            </S.Title>
          </>
        ) : (
          <SkeletonLoader width="160px" height="19.19px" />
        )}
      </S.InnerBox>
    </S.Box>
  );
};
